import React, { useState, useEffect } from "react";
import DialogMessage from "../../../../components/DialogMessage";
import { TypeDialogMessageEnum } from "../../../../model/Enums/TypeDialogMessageEnum";
import DialogMessageProps from "../../../../model/DialogMessageProps";
import GenericUtils from "../../../../utils/GenericUtils";

interface IModalStatus {
    success: boolean;
}

const ModalStatusInformation: React.FC<IModalStatus> = ({ success }) => {
    const [dialogMessageProps, setDialogMessageProps] =
        useState<DialogMessageProps>({} as DialogMessageProps);
    const successMessage = "Upload Concluído";

    const handleCloseDialogMessage = () => {
        setDialogMessageProps({} as DialogMessageProps);
    };

    const typeDialogMessage = (typeIcon: any) => {
        return success ? TypeDialogMessageEnum.Success : typeIcon;
    };

    useEffect(() => {
        const textMessage = success ? successMessage : "Arquivo Inválido";

        const dialog = {
            ...GenericUtils.getPropsDialogError(success),
            onClose: handleCloseDialogMessage,
            title: textMessage,
        };

        setDialogMessageProps(dialog);
    }, [success]);

    return (
        <DialogMessage
            type={typeDialogMessage(dialogMessageProps.type)}
            show={dialogMessageProps.show}
            title={dialogMessageProps.title}
            text={dialogMessageProps.text}
            onClose={dialogMessageProps.onClose}
        />
    );
};

export default ModalStatusInformation;
